// 手机买电影 微信
import filmIndex from '@/views/entertainment/film/index'

const wxRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `film/wx/index${i + 1}`,
  name: `film/wx/Index${i + 1}`,
  component: () => import(`@/views/entertainment/film/wx/index${i + 1}.vue`)
}))
const branchFilmWxRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `film/wx/branch/index${i + 1}`,
  name: `film/wx/branch/Index${i + 1}`,
  component: () => import(`@/views/entertainment/film/wx/branch/index${i + 1}.vue`)
}))
// 手机买电影 支付宝
const zfbRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `film/zfb/index${i + 1}`,
  name: `film/zfb/Index${i + 1}`,
  component: () => import(`@/views/entertainment/film/zfb/index${i + 1}.vue`)
}))
const branchFilmZfbRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `film/zfb/branch/index${i + 1}`,
  name: `film/zfb/branch/Index${i + 1}`,
  component: () => import(`@/views/entertainment/film/zfb/branch/index${i + 1}.vue`)
}))

export default {
  path: '/entertainment',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'film/index',
      name: 'filmIndex',
      component: filmIndex
    },

    ...wxRoutes,
    ...branchFilmWxRoutes,
    ...zfbRoutes,
    ...branchFilmZfbRoutes

  ]
}
